/*
 * @Author: 范向玲
 * @Date: 2022-10-08 16:16:00
 * @LastEditors: 王佳宾
 * @LastEditTime: 2022-10-14 16:11:29
 * @Description: 数据管理表格配置
 * @FilePath: \src\components\DataManagement\audit\tableConfig.js
*/
const tableConfig = [
  {
    title: '序号',
    slots: { customRender: 'serial', },
    ellipsis: true,
    width: 60,
    align: 'center',
  },
  {
    title: '主矿种',
    dataIndex: 'primaryCommodity',
    slots: { customRender: 'primaryCommodity', },
    ellipsis: true,
    align: 'center',
  },
  {
    title: '项目名称',
    dataIndex: 'propName',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '国家',
    dataIndex: 'countryName',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '省份',
    dataIndex: 'stateProvince',
    ellipsis: true,
    align: 'center',
    width: 100,
  },
  {
    title: '全部矿种',
    dataIndex: 'commoditiesList',
    slots: { customRender: 'commoditiesList', },
    ellipsis: true,
    align: 'center',
    width: 200,
  },
  {
    title: '矿权类型',
    dataIndex: 'claimType',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '开发阶段',
    dataIndex: 'devStage',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '运营商',
    dataIndex: 'operatorName',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '填表人',
    dataIndex: 'userName',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '审查人',
    dataIndex: 'checkName',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '联系电话',
    dataIndex: 'phone',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '填写日期',
    dataIndex: 'createTime',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '信息情况',
    dataIndex: 'status',
    ellipsis: true,
    align: 'center',
    slots: { customRender: 'status', },
  },
  {
    title: '提交类型',
    dataIndex: 'type',
    ellipsis: true,
    align: 'center',
    slots: { customRender: 'type', },
  },
  {
    title: '修改备注',
    dataIndex: 'remark',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '操作',
    width: 150,
    key: 'action',
    slots: { customRender: 'action', },
    align: 'center',
  },
];

export default tableConfig;
